import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import plus from "../../assets/icons/Plus.svg";
import {
  ADD_COMPANY,
  API_URL,
  CREATE_UNLINK,
  DELETE_Contacts,
  UPDATE_COMPANY,
} from "../../redux/constants/type";
import "../../assets/styles/local/Addcontact.css";
// import { DELETE_CONTACT_CLIENT } from "..//..//redux/constants/type";
// import { CorpuretIcon, TaskIcon } from "..//..//assets";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import moment from "moment";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  AiFillPlusCircle,
  AiOutlineCloseCircle,
  AiOutlinePlus,
} from "react-icons/ai";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import { IoIosLock } from "react-icons/io";
import {} from "react-icons/md";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import style from "styled-components";
import docicons from "../../assets/icons/Group 2949.svg";
import {
  AddCompanyContact,
  // AddDocToUserContacts,
  AddDocToClients,
  CreateUnlinkContact,
  DeleteContacts,
  DeleteDocs,
  FetchContactsByClientId,
  FetchDocsClientById,
  FetchLinkClientById,
  FetchSearchClients,
  RemoveDocsClientById,
  UpdateCompanyContact,
  FetchManagersList,
} from "../../redux/actions/action";
import Bin from "../../assets/icons/Bin.svg";
import BinB from "../../assets/icons/Binblue.svg";
import Image5 from "../../assets/icons/Group 1277.svg";
import Image3 from "../../assets/icons/Group 514.svg";
import Kebab from "../../assets/icons/Kebab contacts.svg";
import Image4 from "../../assets/icons/Union112.svg";
// import {
//   fetchLinkClients,
//   fetchContactsByClientId,
//   addGlobalClientName,
//   linkOrAddClient,
//   fetchLinkClientById,
//   udpdateLinkClient,
//   addDocManageAccess,
//   fetchAccessByDocContactId,
// } from "../../redux/actions/action";
import { Col, Row } from "react-bootstrap";
import { useHistory, useLocation, useParams } from "react-router-dom";
import AppDatePicker from "../../components/Common/AppDatePicker";
import ContactTaskModal from "../../components/Dailogs/AddTaskModal";
import DeletePopUp from "../../components/Dailogs/DeletePopUp";
import Header from "../../layouts/Header";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";

const AddCompany = () => {
  const history = useHistory();
  const { id } = useParams();
  const refAccountManager = useRef();
  const location = useLocation();
  const path = location.pathname;
  const [primaryColor, setPrimaryColor] = useState(
    window.localStorage.getItem("primarycolor")
  );
  const refCompanyDropdownContainer = useRef();
  const userid = window.localStorage.getItem("userid");
  const [error, setError] = useState(false);
  const [popups, setPopups] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const clientContacts = useSelector(
    (state) => state.user.FetchContactsByClientIddata
  );
  const deleteContactClientResponse = useSelector(
    (state) => state.user.DeleteContactsdata
  );
  const createUnlinkContactResponse = useSelector(
    (state) => state.user.CreateUnlinkContactdata
  );
  const searchClientResponse = useSelector(
    (state) => state.user.FetchSearchClientsdata
  );
  const docsContactListResponse = useSelector(
    (state) => state.user.FetchLinkClientByIdData
  );
  const singleLinkClientData = useSelector(
    (state) => state.user.FetchLinkClientByIddata
  );
  const linkOrAddClientResponse = useSelector(
    (state) => state.user.AddCompanys
  );
  const updateLinkClientResponse = useSelector(
    (state) => state.user.UpdateCompanyContactdata
  );
  const fetchUsersByCompanyResponse = useSelector(
    (state) => state.user.fetchUsersByCompany
  );
  const docManageAccessResponse = useSelector(
    (state) => state.user.docManageAccessResponse
  );
  const DeleteDocsdataRes = useSelector((state) => state.user.DeleteDocsdata);
  const AddDocToClientsdata = useSelector(
    (state) => state.user.AddDocToClientsdata
  );
  const fetchAllManagers = useSelector((state) => state.user.FetchManagersList);

  const globalContactId = useSelector((state) => state.user.globalContactId);
  const companyId = window.localStorage.getItem("companyId");
  const clientId2 = window.localStorage.getItem("clientId2");
  const fetchDocAccess = useSelector((state) => state.user.fetchDocAccess);
  const dispatch = useDispatch();
  // const [rotate, setRotate] = useState(false);
  const [rotate, setRotate] = useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [filelist, setFilelist] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  const selectDoc = useRef(null);
  const [showDropPeople, setShowDropPeople] = useState(false);
  const [loadSwitchcompany, setLoadSwitchcompany] = useState(false);
  const [clientContactList, setClientContactList] = useState([]);
  const [modal, showModal] = useState(false);
  const [deleteUser, setDeleteUser] = useState("");
  const [deleteUserRes, setDeleteUserRes] = useState([]);
  const [show2, setShow2] = useState(false);
  const [unlinkContact, setUlnlinkContact] = useState("");
  const [finalContact, setFinalContact] = useState("");
  const [disableBtn, setDisableBtn] = useState(true);
  const [testingName, setTestingName] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  ///////////////////////////////DATA VALUES STATE///////////////////////////////
  const [cancelAlert, setCancelAlert] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [officePhone, setOfficePhone] = useState("");
  const [mobilePhone, setMobilePhone] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [alternativeEmail, setAlternativeEmail] = useState("");
  const [employee, setEmployee] = useState("");
  const [url, setUrl] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [paymentConditions, setPaymentConditions] = useState("");
  const [notes, setNotes] = useState("");
  const [street, setStreet] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [country, setCountry] = useState("");
  const [roleId, setRoleId] = useState("");
  const [fulLenghtDocAddContact, setFulLenghtDocAddContact] = useState(false);
  const [docIAddContact, setdocIAddContact] = useState();
  const [peopleAccess, setPeopleAccess] = useState(
    "08da33e9-5a64-4f8c-8d88-49e4982df321"
  );
  const [searchPeople, setSearchPeople] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [removeaddbtn, setRemoveaddbtn] = useState(false);
  const [date, setDate] = useState();
  const [searchingClients, setSearchingClients] = useState([]);
  const [contactDocsList, setContactDocsList] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });
  const [deleteDocument, setDeleteDocument] = useState(false);
  const [deleteRowIndex, setDeleteRowIndex] = useState(null);
  const [clientId, setClientId] = useState("");
  const [newdoc, setNewdoc] = useState([]);
  const [priceAggrement, setPriceAggrement] = useState("Standard");
  const [city, setCity] = useState("");
  const [officePhoneType, setOfficePhoneType] = useState("Office Phone");
  const [mobilePhoneType, setMobilePhoneType] = useState("Mobile Phone");
  const [fileId, setFileId] = useState("");
  const [fileName, setFileName] = useState("");
  const [docAccessList, setDocAccessList] = useState([]);
  const [docPeopleList, setDocPeopleList] = useState([]);
  const [fullDocPeopleList, setFullDocPeopleList] = useState([]);
  const [accessDropList, setAccessDropList] = useState([]);
  const [Show, setShow] = useState(false);
  const [Showagain, setShowagain] = useState(true);
  const [numproduct, setNumproduct] = useState(5);
  const linkContactDocRef = useRef();
  const [fetchTransAddContactTaskList, setFetchTransAddContactTaskList] =
    useState({});
  const tt = (key) => fetchTransAddContactTaskList?.[key] || "";
  const [fetchTransContactTaskList, setFetchTransContactTaskList] = useState(
    {}
  );
  const t = (key) => fetchTransContactTaskList?.[key] || "";
  const [fetchTransAddContactList, setFetchTransAddContactList] = useState({});
  const tttt = (key) => updateCompanyTranslation?.[key] || "";
  const [updateCompanyTranslation, setUpdateCompanyTranslation] = useState({});
  const ttt = (key) => updateCompanyTranslation?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Add-Task").then((res) => {
      setFetchTransContactTaskList(res);
    });
  }, []);
  useEffect(() => {
    fetchScreenTranslations("Add-Company").then((res) => {
      setFetchTransAddContactTaskList(res);
    });
  }, []);
  useEffect(() => {
    fetchScreenTranslations("Update-Company").then((res) => {
      setUpdateCompanyTranslation(res);
    });
  }, []);
  useEffect(() => {
    fetchScreenTranslations("Add-Contact").then((res) => {
      setFetchTransAddContactList(res);
    });
  }, []);
  const loadMore = () => {
    setNumproduct(numproduct + contactDocsList.records.length);
    setShow(true);
    setShowagain(false);
    // setShowmore(false);
  };

  const [fileManageAccess, setFileManageAccess] = useState([
    {
      userid: userid,
      accessid: "08da33e9-5a64-4f8c-8d88-49e4982df323",
    },
  ]);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  //   useEffect(() => {
  //     if (docManageAccessResponse?.status === true) {
  //       dispatch(fetchAccessByDocContactId(globalContactId, fileId));
  //     }
  //   }, [docManageAccessResponse]);

  useEffect(() => {
    if (show2) {
      window.addEventListener("mousedown", handleMouseDownCompanyDD);
    } else {
      window.removeEventListener("mousedown", handleMouseDownCompanyDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDownCompanyDD);
    };
  }, [show2]);

  const handleMouseDownCompanyDD = (event) => {
    if (
      refCompanyDropdownContainer.current &&
      !refCompanyDropdownContainer.current.contains(event.target)
    ) {
      setShow2(false);
    }
  };

  const Wrapper = style.div`
    .react-calendar__tile--active {
      background-color: ${primaryColor} !important;
    }
  `;

  useEffect(() => {
    if (DeleteDocsdataRes?.status === 200) {
      dispatch(FetchDocsClientById(id));
    }
  }, [DeleteDocsdataRes]);

  //   useEffect(() => {
  //     if (fetchDocAccess?.status === true) {
  //       setDocAccessList(fetchDocAccess?.data[0]?.useraccess);
  //       fetchDocAccess?.data[0]?.useraccess.map((drop) => {
  //         accessDropList.push({
  //           userid: drop?.userid,
  //           accesslevelid: drop?.accesslevelid,
  //         });
  //       });
  //     }
  //   }, [fetchDocAccess]);

  useEffect(() => {
    if (path.includes(`/contactlist/add-company/${id}`)) {
      if (clientContacts?.status === 200) {
        setClientContactList(clientContacts?.data?.data);
      }
    }
  }, [clientContacts]);

  useEffect(() => {
    if (docsContactListResponse.status === 200) {
      // setContactDocsList(docsContactListResponse?.data?.data);
      setNewdoc(docsContactListResponse?.data?.data);
    }
  }, [docsContactListResponse]);

  useEffect(() => {
    if (AddDocToClientsdata.status === true) {
      dispatch(FetchDocsClientById(id));
    }
  }, [AddDocToClientsdata]);

  //   useEffect(() => {
  //     if (searchPeople) {
  //       let people = [...fullDocPeopleList];
  //       people = people.filter((people) => {
  //         const fullName = `${people?.userdetails[0]?.firstname} ${people?.userdetails[0]?.lastname}`;
  //         return (
  //           people.userdetails[0].firstname
  //             .toLowerCase()
  //             .startsWith(searchPeople.toLowerCase()) ||
  //           people.userdetails[0].lastname
  //             .toLowerCase()
  //             .startsWith(searchPeople.toLowerCase()) ||
  //           fullName.toLowerCase().startsWith(searchPeople.toLowerCase())
  //         );
  //       });
  //       setDocPeopleList(people);
  //     } else {
  //       setDocPeopleList([...fullDocPeopleList]);
  //     }
  //   }, [searchPeople]);

  //   useEffect(() => {
  //     if (fetchUsersByCompanyResponse.status === true) {
  //       setFullDocPeopleList(fetchUsersByCompanyResponse?.data);
  //       setDocPeopleList(fetchUsersByCompanyResponse?.data);
  //     }
  //   }, [fetchUsersByCompanyResponse]);

  //   useEffect(() => {
  //     dispatch(fetchLinkClients());
  //     return () => {
  //       dispatch({ type: "RESET_COMPANY_DETAILS" });
  //     };
  //   }, []);
  useEffect(() => {
    if (id) {
      dispatch(FetchLinkClientById(id));
      dispatch(FetchContactsByClientId(id));
      dispatch(FetchDocsClientById(id));
    } else if (clientId2) {
      dispatch(FetchLinkClientById(clientId2));
      dispatch(FetchContactsByClientId(clientId2));
      dispatch(FetchDocsClientById(clientId2));
    }
  }, [id, clientId2]);

  useEffect(() => {
    const contactId = location?.state?.contactId;
    if (contactId) {
      window.localStorage.setItem("active-contact", contactId);
    }

    return () => window.localStorage.removeItem("active-contact");
  }, [location]);
  const handleDeleteDocumentFun = () => {
    if (isUpdating && deleteRowIndex !== null) {
      dispatch(DeleteDocs(deleteRowIndex));
    } else {
      let data = [...contactDocsList.records];
      data.splice(deleteRowIndex, 1);
      setContactDocsList({ records: [...data] });
    }
    setDeleteDocument(false);
    setDeleteRowIndex(null);
  };
  const docUpload = async (file) => {
    const filesizecontvrt = file?.size / 1024;
    if (filesizecontvrt / 1024 > 100) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: "The File is too big: Upload a file of max 100 MB.",
        },
        false
      );
    } else {
      handleGeneralNotification(
        { notificationType: "CUSTOM", text: "Your document is loading" },
        false
      );
    }
    var formData = new FormData();
    formData.append("", file);
    let newfiles = file;
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response !== null) {
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: "Document Uploaded successfully!",
          },
          false
        );
        if (id) {
          setTimeout(() => {
            dispatch(
              AddDocToClients(id, userid, [
                {
                  documentname: newfiles.name,
                  documentextension: newfiles.type,
                  documentcontent: "string",
                  link: response.data[0],
                  documentsize: newfiles.size.toString(),
                },
              ])
            );
          }, 3000);
        } else {
          const modifiedContacts = contactDocsList.records;
          modifiedContacts.push({
            userid: userid,
            documentname: newfiles.name,
            documentextension: newfiles.type,
            documentcontent: "string",
            link: response.data[0],
            documentsize: newfiles.size,
          });

          let records = modifiedContacts || [];
          let tempPaginationObj = {
            totalRecords: records.length,
            currentPage: 1,
            startRecordIndex: Math.max(10 * 1 - 9, 1),
            endRecordIndex: Math.min(10 * 1, records.length),
            totalPages: Math.ceil(records.length / 10),
            records: records?.slice((1 - 1) * 10, 1 * 10),
          };
          setContactDocsList({ ...tempPaginationObj });
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (path.includes(`/contactlist/add-company/${id}`)) {
      if (singleLinkClientData?.status === 200) {
        const singleClient = singleLinkClientData?.data?.data[0];
        setCompanyName(singleClient.clientname);
        setTestingName(singleClient.clientname);
        setZipCode(singleClient.zipcode);
        setCountry(singleClient.country);
        setOfficePhone(singleClient.officePhoneNo);
        setStreet(singleClient.streetNameAndNumber);
        setEmployee(singleClient.numberOfEmployees);
        setVatNumber(singleClient.vatnumber);
        setMobilePhone(singleClient.mobileNo);
        setMobilePhoneType(singleClient.mobileNoType);
        setOfficePhoneType(singleClient.officePhoneNoType);
        setNotes(singleClient.notes);
        setPaymentConditions(singleClient.paymentconditions);
        // setDate(new Date(singleClient.duedate));
        // setDate(singleClient.duedate ? new Date(singleClient.duedate) : new Date());
        setDate(
          singleClient.duedate && singleClient.duedate !== "Invalid date"
            ? new Date(singleClient.duedate)
            : null
        );
        setUrl(singleClient.url);
        setAlternativeEmail(singleClient.alternativeEmail);
        setEmail(singleClient.email);
        setCity(singleClient.city);
        setPoNumber(singleClient.pOnumber);
        // setPriceAggrement(singleClient.priceagreement);
        setClientId(clientId || id);
        setIsUpdating(true);
        setJobname(singleClient.accountmanagername);
        setAccountManagerId(singleClient.accountmanager);
      }
    } else {
      if (singleLinkClientData?.status === 200) {
        const singleClient = singleLinkClientData?.data?.data[0];
        setCompanyName(singleClient.clientname);
        setTestingName(singleClient.clientname);
        setZipCode(singleClient.zipcode);
        setCountry(singleClient.country);
        setOfficePhone(singleClient.officePhoneNo);
        setStreet(singleClient.streetNameAndNumber);
        setEmployee(singleClient.numberOfEmployees);
        setVatNumber(singleClient.vatnumber);
        setMobilePhone(singleClient.mobileNo);
        setMobilePhoneType(singleClient.mobileNoType);
        setOfficePhoneType(singleClient.officePhoneNoType);
        setNotes(singleClient.notes);
        setPaymentConditions(singleClient.paymentconditions);
        setDate(new Date(singleClient.duedate));
        setUrl(singleClient.url);
        setAlternativeEmail(singleClient.alternativeEmail);
        setEmail(singleClient.email);
        setCity(singleClient.city);
        setPoNumber(singleClient.pOnumber);
        // setPriceAggrement(singleClient.priceagreement);
        setClientId(clientId || id);
        setIsUpdating(true);
      }
    }
  }, [singleLinkClientData]);

  //   const deleteContactFunction = async (deleteUser) => {
  //     try {
  //       const response = await axios.post(`${API_URL}/api/User/DeleteContact`, {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         contactid: deleteUser,
  //       });
  //       setDeleteUser("");
  //       // setDeleteUserRes(response);
  //       dispatch({
  //         type: DELETE_CONTACT_CLIENT,
  //         data: response.data,
  //       });
  //       setUlnlinkContact("");
  //       showModal(false);
  //     } catch (error) {

  //     }
  //   };

  useEffect(() => {
    if (linkOrAddClientResponse.status === 200) {
      // const singleClient = linkOrAddClientResponse?.data;
      // dispatch(addGlobalClientName(singleClient?.clientname));
      // return history.push("/contactlist/add-contact");

      let reqArray = [];
      contactDocsList?.records?.forEach((elements) => {
        reqArray.push({
          documentname: elements?.documentname,
          documentextension: elements?.documentextension,
          documentcontent: elements?.documentcontent,
          link: elements?.link,
          documentsize: elements?.documentsize?.toString(),
        });
      });
      window.localStorage.setItem(
        "clientaddname",
        linkOrAddClientResponse?.data?.data?.clientname
      );
      setTimeout(() => {
        dispatch(
          AddDocToClients(
            linkOrAddClientResponse?.data?.data?.clientid,
            userid,
            reqArray
          )
        );
        dispatch({
          type: ADD_COMPANY,
          data: {},
        });
        // history.goBack();
        // window.location.reload();
      }, 5000);

      history.goBack();
    }
  }, [linkOrAddClientResponse]);

  // const UnlinkContactFunction = async (unlinkContact) => {
  //   try {
  //     const response = await axios.post(
  //       `${API_URL}/api/User/CreateUnlinkContact`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         contactid: unlinkContact,
  //       }
  //     );
  //     setDeleteUser("");
  //     setUlnlinkContact("");
  //     showModal(false);
  //   } catch (error) {

  //   }
  // };
  // || city == ""
  // street == "" ||
  const handleAdd = () => {
    // setRemoveaddbtn(true);
    setTypeInScreen("");

    if (companyName === "") {
      setError(true);
    } else {
      if (clientId) {
        setShowLoader(true);
        dispatch(
          UpdateCompanyContact(
            clientId,
            companyName,
            street,
            zipCode,
            city,
            country,
            officePhone,
            officePhoneType,
            mobilePhone,
            mobilePhoneType,
            email,
            alternativeEmail,
            employee,
            url,
            notes,
            vatNumber,
            paymentConditions,
            poNumber,
            accountManagerId,
            date
          )
        );
      } else {
        setShowLoader(true);
        return dispatch(
          AddCompanyContact(
            userid,
            companyName,
            street,
            zipCode,
            city,
            country,
            officePhone,
            officePhoneType,
            mobilePhone,
            mobilePhoneType,
            email,
            alternativeEmail,
            employee,
            url,
            notes,
            vatNumber,
            paymentConditions,
            poNumber,
            accountManagerId,
            date
          )
        );
      }
    }
  };

  useEffect(() => {
    if (updateLinkClientResponse.status === 200) {
      window.localStorage.setItem(
        "clientaddname",
        updateLinkClientResponse?.data?.data?.clientname
      );
      window.localStorage.setItem(
        "clientId2",
        updateLinkClientResponse?.data?.data?.clientid
      );
      dispatch({ type: UPDATE_COMPANY, data: {} });
      dispatch(RemoveDocsClientById());
      history.goBack();
    }
  }, [updateLinkClientResponse]);

  useEffect(() => {
    if (deleteContactClientResponse.status === true) {
      dispatch(FetchContactsByClientId(clientId));
      dispatch({
        type: DELETE_Contacts,
        data: {},
      });
    }
  }, [deleteContactClientResponse]);

  useEffect(() => {
    if (createUnlinkContactResponse.status === true) {
      dispatch(FetchContactsByClientId(clientId));
      dispatch({
        type: CREATE_UNLINK,
        data: {},
      });
    }
  }, [createUnlinkContactResponse]);

  useEffect(() => {
    if (searchClientResponse.status === 200) {
      if (searchClientResponse != null) {
        setSearchingClients(searchClientResponse?.data?.data);
        if (searchClientResponse?.data?.data?.length === 0) {
          setShow2(false);
        }
      }
    }
  }, [searchClientResponse]);

  useEffect(() => {
    if (path.includes(`/contactlist/add-company/${id}`)) {
      setLoadSwitchcompany(true);
    }
  }, [path]);

  useEffect(() => {
    if (companyName && country && street) {
      setDisableBtn(false);
    } else {
      setDisableBtn(true);
    }
  }, [companyName, country, street]);
  useEffect(() => {
    document.addEventListener(
      "click",
      () => {
        setRotate();
      },
      true
    );
    return () => {
      document.removeEventListener("click", setRotate(), true);
    };
  }, []);
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      fontWeight: 400,
      color: "#333333",
      fontSize: "14px",
      background: "#F1F1F1 0% 0% no-repeat padding-box",
      boxShadow: "0px 3px 6px #00000029",
      opacity: 1,
    },
  }));

  const calculatePagination = (pageNumber) => {
    let records = newdoc || [];
    let tempPaginationObj = {
      totalRecords: records.length,
      currentPage: pageNumber,
      startRecordIndex: Math.max(10 * pageNumber - 9, 1),
      endRecordIndex: Math.min(10 * pageNumber, records.length),
      totalPages: Math.ceil(records.length / 10),
      records: records?.slice((pageNumber - 1) * 10, pageNumber * 10),
    };
    setContactDocsList({ ...tempPaginationObj });
  };
  useEffect(() => {
    calculatePagination(1);
  }, [newdoc]);
  const pdfdownload = (event, documentid, documentname) => {
    axios({
      method: "post",
      url: `${API_URL}/api/Files/DownloadToS3?documentid=` + documentid,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
      // data: {
      //   message?.message
      // },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // var el = document.createElement('div');
      const document = window.document || {};
      const link = document.createElement("a");
      link.href = url;
      link.download = documentname;
      document.body.appendChild(link);
      link.click();
    });
  };

  const handleUploadDoc = () => {
    linkContactDocRef.current.click();
  };

  const uploadDocForContactAndRedirect = async (e, finalContact) => {
    const target = e.target.files[0];
    var formData = new FormData();
    formData.append("", target);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response !== null) {
        setTimeout(() => {
          axios({
            method: "post",
            url: `${API_URL}/api/Files/Adddocumenttocontact`,
            headers: {
              "Content-Type": "application/json",
            },
            data: {
              contactid: finalContact,
              userid: userid,
              docs: [
                {
                  documentname: e.target.files[0].name,
                  documentextension: e.target.files[0].type,
                  documentcontent: "string",
                  link: response.data[0],
                  documentsize: e.target.files[0].size,
                },
              ],
            },
          }).then((response) => {
            if (response?.data?.status === true) {
              setAnchorEl(null);
              window.localStorage.setItem("Doc", "Doc");
              history.push(`/contactlist/edit-contact/${finalContact}`);
            }
          });
        }, 1000);
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: "Document Uploaded successfully!",
          },
          false
        );
      }
    } catch (error) {}
  };

  const handleContactAssignTask = (contactId) => {
    setAddTaskModal(true);
    handleClose();
  };

  const handleFileChange = (e) => {
    const target = e.target.files[0];
    let formData = new FormData();
    formData.append("file", target);
    axios
      .put(`${API_URL}/api/Files/UploadToS3`, formData)
      .then(function (response) {
        if (response !== null) {
          setImgUrl(response.data[0]);
        }
      })
      .catch(function (error) {});
  };

  const [addTaskModal, setAddTaskModal] = useState(false);
  const [enablecomm, setEnableComm] = useState(false);
  const [showcmnt, setShowcmnt] = useState(true);
  const [length, setLength] = useState("");
  const [imgUrl, setImgUrl] = useState("");
  const [showAP, setAPShow] = useState([]);
  const [maxComments, setMaxComments] = useState([]);
  const [showAccountManagerDrop, setShowAccountManagerDrop] = useState(false);
  const [jobname, setJobname] = useState("");
  const [clientSearch, setClientSearch] = useState("");
  const [managerList, setManagerList] = useState([]);
  const [accountManagerId, setAccountManagerId] = useState(
    "00000000-0000-0000-0000-000000000000"
  );

  useEffect(() => {
    dispatch(FetchManagersList());
    // checkIfTempData();
    return () => {
      window.localStorage.removeItem("active-contact");
      // setCanGoBack(false);
      dispatch({ type: "RESET_ADD_UPDATE_CONTACT" });
    };
  }, []);

  useEffect(() => {
    if (fetchAllManagers != null) {
      if (fetchAllManagers.status === 200) {
        setManagerList(fetchAllManagers?.data);
      }
    }
  }, [fetchAllManagers]);

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      refAccountManager.current &&
      !refAccountManager.current.contains(event.target)
    ) {
      setShowAccountManagerDrop(false);
    }
    // if (type_an_item_Drop_Ref.current && !type_an_item_Drop_Ref.current.contains(event.target)) {
    //   setShowProductsPeople(false);
    // }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  //// ASC FOR ALERT START ////

  const roleAccess = window.localStorage.getItem("roleid");
  const [alert, setAlert] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (roleAccess === process.env.REACT_APP_IS_VIEWER) {
        setAlert(true);
      }
    }, 1000);
  }, []);

  const handleClose_Modal = () => setAlert(false);

  //// ASC FOR ALERT END ////

  const handleEmailChange = (e) => {
    setTypeInScreen(e.target.value);
    const emailValue = e.target.value;
    setEmail(emailValue);
    setCancelAlert(true);
    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Check if the email is valid
    if (!emailRegex.test(emailValue)) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
  };

  const handelCancel = () => {
    if (cancelAlert) {
      setPopups(true);
    } else {
      dispatch(RemoveDocsClientById());
      history.goBack();
    }
  };

  const [typeInScreen, setTypeInScreen] = useState("");

  // for add doc from company list start.
  const handleTriggerFileInput = () => {
    if (selectDoc.current) {
      selectDoc.current.click();
    }
  };

  useEffect(() => {
    if (localStorage.getItem("addDocCompanyList")) {
      handleTriggerFileInput();
    }
    localStorage.removeItem("addDocCompanyList");
  }, []);
  // for add doc from company list end.

  return (
    <>
      <Header />

      {/* <RouteLeavingGuard
        when={typeInScreen !== ""}
        navigate={history.push}
        shouldBlockNavigation={(location) =>
          typeInScreen !== "" &&
          !["/add-purchasing-order", "/stock"].includes(location.pathname)
        }
      /> */}

      <RouteLeavingGuard
        when={typeInScreen !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (typeInScreen !== "") {
            if (
              ![
                "/contactlist/add-company",
                "/contactlist/add-company/:id",
              ].includes(location.pathname)
            ) {
              return true;
            }
          }
          return false;
        }}
      />

      {addTaskModal && (
        <ContactTaskModal
          showModal={addTaskModal}
          setTaskid={() => {}}
          setShowModal={(show, reload) => {
            setAddTaskModal(false);
            if (reload) {
              window.localStorage.setItem("Task", "Task");
              history.push(`/contactlist/edit-contact/${finalContact}`);
            }
          }}
          defaultContactId={finalContact}
          setComments={() => {}}
          modalFunction={"add"}
          setEnableComm={setEnableComm}
          setShowcmnt={setShowcmnt}
          enablecomm={enablecomm}
          showcmnt={showcmnt}
          setMessage={() => {}}
          message={""}
          handleFileChange={handleFileChange}
          handleAddComments={() => {}}
          maxComments={maxComments}
          show={showAP}
          length={length}
          setLength={setLength}
          setShow={setAPShow}
          imgUrl={imgUrl}
          setImgUrl={setImgUrl}
          setMaxComments={setMaxComments}
          from={moment().toDate()}
          searchText={""}
        />
      )}
      <Modal
        show={alert}
        onHide={handleClose_Modal}
        backdrop="static"
        keyboard={false}
        // {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>You don't have permission to update this.</Modal.Body>
        <Modal.Footer>
          <Button style={{ background: "#0073c7" }} onClick={handleClose_Modal}>
            Understood
          </Button>
        </Modal.Footer>
      </Modal>

      <section className="main-add-contact ps-4 pe-4">
        <div className="ps-4 pe-4">
          <Row>
            <Col xl={12} lg={12} md={12} sm={12}>
              <p
                className="fw-bold mt-2 "
                style={{
                  fontSize: "20px",
                  color: "#333333",
                  marginLeft: "-20px",
                }}
              >
                Contacts
              </p>
            </Col>
          </Row>
        </div>
        <section className="add-contact-info-container add-company-info-container">
          <div className="column-1-contact-list-linked" id="column-1-info-id">
            <div
              className="comp-head pt-4 px-4 pb-2"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                ref={refCompanyDropdownContainer}
                className="position-relative"
              >
                <input
                  type="text"
                  placeholder={`${tt("Add Company name")} *`}
                  className={
                    street == "" && error == true
                      ? "input-name-style-address"
                      : "companyname-input"
                  }
                  value={companyName}
                  onChange={(e) => {
                    setCancelAlert(true);
                    setCompanyName(e.target.value);
                    setTypeInScreen(e.target.value);
                    setShow2(true);
                    dispatch(FetchSearchClients(e.target.value));
                  }}
                  style={{ textOverflow: "ellipsis" }}
                />
                {show2 && (
                  <div
                    className="scroll-fix"
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      borderRadius: "4px",
                      boxShadow: "0px 3px 12px #3b45581a",
                      backgroundColor: "#ffffff",
                      height: "120px",
                      overflowY: "auto",
                      overflowX: "hidden",
                      width: "100%",
                      zIndex: "2",
                    }}
                  >
                    {searchingClients?.map((items, i) => {
                      return (
                        <>
                          {loadSwitchcompany ? (
                            <p
                              key={i}
                              className="ps-2 pe-2"
                              onClick={() => {
                                setCompanyName(items?.clientname);
                                setShow2(false);
                                setClientId(items?.clientid);
                                setSearchingClients([]);
                                dispatch(FetchLinkClientById(items?.clientid));
                                dispatch(
                                  FetchContactsByClientId(items?.clientid),
                                );
                                dispatch(FetchDocsClientById(items?.clientid));
                              }}
                            >
                              {items?.clientname?.length >= 20
                                ? items?.clientname?.substring(0, 20) + "..."
                                : items?.clientname}
                            </p>
                          ) : (
                            <p
                              key={i}
                              className="ps-2 pe-2"
                              onClick={() => {
                                setSearchingClients([]);
                                setShow2(false);
                                history.replace(
                                  `/contactlist/add-company/${items?.clientid}`,
                                );
                              }}
                            >
                              {items?.clientname?.length >= 20
                                ? items?.clientname?.substring(0, 20) + "..."
                                : items?.clientname}
                            </p>
                          )}
                        </>
                      );
                    })}
                  </div>
                )}
              </div>

              <div className="componentC-container" style={{ width: "100%" }}>
                {/* <input
                  style={{
                    width: "100%",
                    fontSize: "14px",
                    fontWeight: 500,
                    textAlign: "center",
                    color: "#333333",
                  }}
                  className={
                    street == "" && error == true
                      ? "input-name-style-address"
                      : "input-style"
                  }
                  type="text"
                  value={street}
                  placeholder={fetchTransAddContactTaskList[10]?.translation}
                  onChange={(e) => {
                    setStreet(e.target.value);
                    setCancelAlert(true);
                  }}
                /> */}

                <GooglePlacesAutocomplete
                  debounce={800}
                  placeholder={tt("Add address")}
                  renderInput={(props) => (
                    <textarea
                      style={{
                        border: "none",
                        width: "100%",
                        overflow: "hidden",
                      }}
                      {...props}
                      rows={2}
                      placeholder={tt("Add address")}
                    />
                  )}
                  onSelect={(e) => {
                    setStreet(e.description);
                    setCancelAlert(true);
                    setTypeInScreen("asc");
                  }}
                  initialValue={street}
                />
              </div>

              <div
                className=" componentB-container"
                style={{ textAlign: "center" }}
              >
                {/* <input
                  style={{
                    // width: "300%",
                    marginTop: "0",
                    fontSize: "14px",
                    color: "#A5A5A5",
                    textAlign: "center",
                  }}
                  className={
                    country == "" && error == true
                      ? "input-name-style-address input-style  "
                      : "input-style add-contact-input-style"
                  }
                  type="text"
                  value={country}
                  placeholder={updateCompanyTranslation[9]?.translation}
                  onChange={(e) => { setCountry(e.target.value); setCancelAlert(true); }}
                /> */}
              </div>
            </div>
            <div className="client-details">
              <div className="other-grid-2">
                <div className="client-grid-div">
                  {" "}
                  <PhoneInput
                    placeholder=""
                    country={"nl"}
                    enableSearch={true}
                    value={officePhone}
                    onChange={(phone) => {
                      setOfficePhone(phone);
                      setCancelAlert(true);
                      setTypeInScreen("asc");
                    }}
                    className="flag-inputfield"
                  />
                  <div className="underline-contact"></div>
                  <p className="text-heading-styles">
                    {/* {updateCompanyTranslation[10]?.translation} */}
                    {ttt("")}
                  </p>
                </div>
                <div className="client-grid-div">
                  {" "}
                  <PhoneInput
                    placeholder=""
                    country={"nl"}
                    enableSearch={true}
                    value={mobilePhone}
                    onChange={(phone) => {
                      setMobilePhone(phone);
                      setCancelAlert(true);
                      setTypeInScreen("asc");
                    }}
                    className="flag-inputfield addjust"
                  />
                  <div className="underline-contact"></div>
                  <p className="text-heading-styles">
                    {/* {updateCompanyTranslation[11]?.translation} */}
                    {ttt("")}
                  </p>
                </div>
              </div>
              <div className="other-grid-3 mt-2">
                <input
                  type="email"
                  className="input-style addClientInput add-contact-input-style"
                  value={email}
                  onChange={handleEmailChange}
                />
                <div
                  className={
                    emailError ? "underline-contact1" : "underline-contact"
                  }
                ></div>
                <p
                  className={
                    emailError ? "text-heading-styles1" : "text-heading-styles"
                  }
                  style={{
                    marginBottom: emailError ? "0" : "2rem",
                  }}
                >
                  {/* {updateCompanyTranslation[12]?.translation} */}
                  {ttt("")}
                </p>
                {/* {emailError && (
                  <div className="warning">
                    <i className=" bi bi-exclamation-circle"></i>&nbsp;
                    Incorrect email
                  </div>
                )} */}
              </div>

              {/* Account Manager start */}
              <div className="other-grid-3 col--12 col-lg--6">
                <div
                  ref={refAccountManager}
                  style={{
                    position: "relative",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                    onClick={() => {
                      setShowAccountManagerDrop(!showAccountManagerDrop);
                    }}
                  >
                    <p
                      className="margin-0 ms-18-bold Client-input-service"
                      style={{
                        color: "#333333",
                        fontWeight: 400,
                        fontSize: "14px",
                      }}
                      onClick={() => {
                        setShowAccountManagerDrop(!showAccountManagerDrop);
                      }}
                    >
                      {(jobname && jobname) || "Select"}
                    </p>
                    <i
                      className="bi bi-chevron-down fw-bold"
                      style={{
                        fontSize: "10px",
                        color: "#333333",
                        marginRight: "5px",
                      }}
                    ></i>
                  </div>

                  {showAccountManagerDrop && (
                    <div
                      className="client-drop-servic"
                      style={{ width: "435px" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                        onClick={() => {
                          setShowAccountManagerDrop(false);
                        }}
                      ></div>

                      <div
                        className="client-search-main1 account-manager-dropdown"
                        style={{ marginBottom: "10px" }}
                      >
                        <input
                          type="text"
                          value={clientSearch}
                          style={{
                            margin: "0 0 0 0rem",
                            opacity: "0.5",
                            borderBottom: "1px solid #A5A5A5",
                            color: "#A5A5A5",
                            fontsize: "14px",
                            fontWeight: clientSearch ? "400" : "300",
                          }}
                          placeholder="Search"
                          className="search-style select-client-div border-black"
                          onChange={(e) => {
                            setClientSearch(e.target.value);
                          }}
                        />
                      </div>
                      <div className="service-list-hieght">
                        {managerList?.data
                          ?.filter((data) =>
                            data?.managername
                              ?.toLowerCase()
                              .includes(clientSearch?.toLowerCase()),
                          )
                          .map((project, i) => {
                            let existItem = false;
                            if (accountManagerId === project.managerid) {
                              existItem = true;
                            }
                            return (
                              <>
                                <div
                                  style={{
                                    backgroundColor: existItem ? "#d8d8e5" : "",
                                  }}
                                  className="d-flex pt-1 pb-1"
                                >
                                  {project?.managerimage ? (
                                    <img
                                      alt=""
                                      src={project?.managerimage}
                                      height="24px"
                                      width="24px"
                                      style={{
                                        borderRadius: "50px",
                                      }}
                                    />
                                  ) : (
                                    <div
                                      style={{
                                        borderRadius: "50px",
                                        height: "24px",
                                        width: "24px",
                                        backgroundColor: "#95A7C6",
                                        color: "#FFFFFF",
                                        display: "flex",
                                        justifyContent: "center",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                        alignItems: "center",
                                      }}
                                    >
                                      {project?.managername
                                        ?.slice(0, 2)
                                        .toUpperCase()}
                                      {/* <p
                                                      style={{
                                                        fontSize: "14px",
                                                      }}
                                                    >
                                                    
                                                    </p> */}
                                    </div>
                                  )}

                                  <p
                                    className="margin-0 ps-2"
                                    key={i}
                                    style={{
                                      textTransform: "capitalize",
                                      fontSize:
                                        " clamp(14px, 1.025vw, 0.833vw)",
                                    }}
                                    onClick={() => {
                                      // let listcontactid = project?.id;
                                      // let contactname = project?.name;
                                      // let contacttype = project?.type;
                                      setAccountManagerId(project?.managerid);
                                      setJobname(project?.managername);
                                      setShowAccountManagerDrop(false);
                                      // setChangeComp(project?.managername);
                                    }}
                                  >
                                    {project?.managername}
                                  </p>
                                </div>
                              </>
                            );
                          })}
                      </div>
                    </div>
                  )}
                </div>
                <div className="underline-contact"></div>
                <p className="text-heading-styles">
                  {tttt("Account Manager")}
                </p>
              </div>
              {/* Account Manager end */}

              <div className="other-grid-2">
                <div className="client-grid-div">
                  <span className="info-styles">
                    {/* {updateCompanyTranslation[13]?.translation} */}
                    {ttt("")}
                  </span>
                  <input
                    type="number"
                    className="input-style addClientInput add-contact-input-style pt-3"
                    value={employee}
                    onChange={(e) => {
                      setEmployee(e.target.value);
                      setCancelAlert(true);
                      setTypeInScreen(e.target.value);
                    }}
                  />
                  <div className="underline-contact"></div>
                  <p className="text-heading" style={{ color: "#333333" }}>
                    {/* {updateCompanyTranslation[15]?.translation} */}
                    {ttt("")}
                  </p>
                  <input
                    type="text"
                    className="input-style addClientInput add-contact-input-style"
                    value={url}
                    onChange={(e) => {
                      setUrl(e.target.value);
                      setCancelAlert(true);
                      setTypeInScreen(e.target.value);
                    }}
                  />
                  <div className="underline-contact"></div>
                  <p
                    className="text-heading-styles"
                    style={{ color: "#333333" }}
                  >
                    {/* {updateCompanyTranslation[17]?.translation} */}
                    {ttt("")}
                  </p>
                  <div>
                    <input
                      type="text"
                      className="input-style input-width-main addClientInput add-contact-input-style"
                      value={poNumber}
                      onChange={(e) => {
                        setPoNumber(e.target.value);
                        setCancelAlert(true);
                        setTypeInScreen(e.target.value);
                      }}
                    />
                    <div className="underline-contact"></div>
                    <p
                      className="text-heading-styles"
                      style={{ color: "#333333" }}
                    >
                      {/* {updateCompanyTranslation[19]?.translation} */}
                      {ttt("")}
                    </p>
                  </div>
                  <p className="text-heading-styles mt-4 mb-1 notesStyle">
                    {/* {updateCompanyTranslation[21]?.translation} */}
                    {ttt("")}
                  </p>
                  <textarea
                    type="text"
                    className="notes-input-style textareabox add-contact-input-style"
                    style={{ border: "0.5px solid #A5A5A5", resize: "auto" }}
                    value={notes}
                    onChange={(e) => {
                      setNotes(e.target.value);
                      setCancelAlert(true);
                      setTypeInScreen(e.target.value);
                    }}
                  />
                </div>
                <div className="client-grid-div">
                  {" "}
                  <span className="info-styles">
                    {/* {updateCompanyTranslation[14]?.translation} */}
                    {ttt("")}
                  </span>
                  <input
                    type="text"
                    className="input-style addClientInput add-contact-input-style pt-3"
                    value={vatNumber}
                    onChange={(e) => {
                      setVatNumber(e.target.value);
                      setCancelAlert(true);
                      setTypeInScreen(e.target.value);
                    }}
                  />
                  <div className="underline-contact"></div>
                  <p className="text-heading" style={{ color: "#333333" }}>
                    {/* {updateCompanyTranslation[16]?.translation} */}
                    {ttt("")}
                  </p>
                  <div className="d-flex add-contact-input-style">
                    <input
                      type="number"
                      className="input-style addClientInput"
                      style={{ width: "40px" }}
                      value={paymentConditions}
                      onChange={(e) => {
                        // setPaymentConditions(e.target.value);
                        // setCancelAlert(true);
                        // setTypeInScreen(e.target.value);

                        // for not more then 3 digit👇.
                        const value = e.target.value;
                        if (value.length <= 3) {
                          setPaymentConditions(value);
                          setCancelAlert(true);
                          setTypeInScreen(value);
                        }
                      }}
                      // placeholder="30 days"
                    />
                    <span>Days</span> {/* Display "Days" after the input */}
                  </div>
                  <div className="underline-contact"></div>
                  <p
                    className="text-heading-styles"
                    style={{ color: "#333333" }}
                  >
                    {/* {updateCompanyTranslation[18]?.translation} */}
                    {ttt("")}
                  </p>
                  <div className="po-due-grid add-company-DatePicker">
                    {/* <div>
                      <input
                        type="text"
                        className="input-style input-width-main addClientInput add-contact-input-style"
                        value={poNumber}
                        onChange={(e) => {
                          setPoNumber(e.target.value);
                        }}
                      />
                      <div className="underline-contact"></div>
                      <p className="text-heading-styles">PO Number</p>
                    </div> */}
                    {/* <Wrapper
                      style={{
                        textAlign: "start",
                        marginTop: "2px",
                       
                      }}
                    > */}

                    <AppDatePicker
                      selected={date}
                      onChange={(date) => {
                        setDate(date);
                        setCancelAlert(true);
                        setTypeInScreen("asc");
                      }}
                      dateFormat="dd/MM/yyyy"
                      inputClassNames={"dateFont"}
                    />
                    <div className="underline-contact"></div>
                    <p
                      className="text-heading-styles"
                      style={{ color: "#333333" }}
                    >
                      {/* {updateCompanyTranslation[20]?.translation} */}
                      {ttt("")}
                    </p>
                  </div>
                  <input
                    type="file"
                    accept=".doc,.pdf,.xls,.xlsx,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    name="doc"
                    id="doc"
                    style={{ display: "none" }}
                    ref={selectDoc}
                    onChange={(event) => {
                      setCancelAlert(true);
                      setTypeInScreen(event.target.value);
                      const fileUploaded = event.target.files[0];
                      if (fileUploaded) {
                        const image = URL.createObjectURL(fileUploaded);
                        docUpload(fileUploaded);
                      } else {
                        return;
                      }
                    }}
                  />
                  <div className="d-flex" style={{ alignItems: "center" }}>
                    <p
                      className={
                        roleAccess === process.env.REACT_APP_IS_VIEWER
                          ? "pointerEvent dotstyle"
                          : "dotstyle"
                      }
                      // style={{
                      //   textAlign: "start",
                      //   color: "#00246A",
                      //   cursor: "pointer",
                      //   marginTop: "20px",
                      //   fontSize: "12px",
                      //   fontWeight: 500,
                      // }}
                      onClick={(e) => {
                        e.preventDefault();
                        selectDoc.current.click();
                      }}
                    >
                      {/* {updateCompanyTranslation[22]?.translation} */}
                      {ttt("")}
                      <img
                        src={plus}
                        width="15px"
                        height="15px"
                        alt="+"
                        style={{
                          color: `${primaryColor}`,
                          marginLeft: "0.25rem",
                        }}
                        className="responsive-check"
                      />{" "}
                    </p>
                    {contactDocsList.records.length > 5 && (
                      <span
                        className={Showagain ? "ps-5" : "d-none"}
                        onClick={() => loadMore()}
                        style={{
                          color: "#333333",
                          fontWeight: "bold",
                          cursor: "pointer",
                          fontSize: "12px",
                        }}
                      >
                        Show More...
                      </span>
                    )}
                    {Show && (
                      <span
                        className="ps-5"
                        onClick={() => {
                          setNumproduct(5);
                          setShow(false);
                          setShowagain(true);
                        }}
                        style={{
                          color: "#333333",
                          fontWeight: "bold",
                          cursor: "pointer",
                          fontSize: "12px",
                        }}
                      >
                        Show Less...
                      </span>
                    )}
                  </div>
                  {contactDocsList.records
                    ?.slice(0, numproduct)
                    ?.map((doc, index) => {
                      return (
                        <div
                          className="doc-table-headings"
                          style={{
                            gridTemplateColumns: "7fr 1fr",
                          }}
                        >
                          {doc?.filename?.length > 30 ||
                          doc?.documentname?.length > 30 ? (
                            <LightTooltip
                              title={doc?.filename || doc?.documentname}
                              placement="top-start"
                            >
                              <div
                                onMouseOver={() => {
                                  setdocIAddContact(index);
                                  if (
                                    doc?.filename?.length > 30 ||
                                    doc?.documentname?.length > 30
                                  ) {
                                    setFulLenghtDocAddContact(true);
                                    setdocIAddContact(index);
                                  }
                                }}
                                onMouseOut={() => {
                                  setFulLenghtDocAddContact(false);
                                  setdocIAddContact("");
                                }}
                                style={{ width: "11vw", cursor: "pointer" }}
                                className="truncated-text2"
                                onClick={(e) => {
                                  if (isUpdating) {
                                    pdfdownload(
                                      e,
                                      doc?.documentid,
                                      doc.filename,
                                    );
                                  }
                                }}
                              >
                                {" "}
                                {doc?.filename || doc?.documentname}
                              </div>
                            </LightTooltip>
                          ) : (
                            <div
                              style={{ width: "11vw", cursor: "pointer" }}
                              className="truncated-text2"
                              onClick={(e) => {
                                if (isUpdating) {
                                  pdfdownload(e, doc?.documentid, doc.filename);
                                }
                              }}
                            >
                              {" "}
                              {doc?.filename || doc?.documentname}
                            </div>
                          )}
                          <img
                            src={BinB}
                            alt="dlt"
                            style={{
                              width: "14px",
                              height: "15px",
                              cursor: "pointer",
                            }}
                            // className="pe-1"
                            className={
                              roleAccess === process.env.REACT_APP_IS_VIEWER
                                ? "d-none pe-1"
                                : "pe-1"
                            }
                            onClick={() => {
                              setDeleteRowIndex(doc.documentid);
                              setDeleteDocument(true);
                            }}
                          />
                        </div>
                      );
                    })}
                  {contactDocsList.records.length > 9 || Show ? (
                    <div className={Showagain ? "d-none" : "custom-pagination"}>
                      <div className="range-text">
                        {`${contactDocsList.startRecordIndex} - ${contactDocsList.endRecordIndex} of ${contactDocsList.totalRecords}`}
                      </div>
                      <div className="pagination-buttons">
                        <div
                          className={`pagination-button ${
                            contactDocsList.currentPage === 1 ? "disabled" : ""
                          }`}
                          onClick={() =>
                            calculatePagination(contactDocsList.currentPage - 1)
                          }
                        >
                          <BsChevronLeft />
                        </div>
                        <div className="pagination-current-page">
                          {contactDocsList.currentPage}
                        </div>
                        <div
                          className={`pagination-button ${
                            contactDocsList.totalPages === 0 ||
                            contactDocsList.totalPages ===
                              contactDocsList.currentPage
                              ? "disabled"
                              : ""
                          }`}
                          onClick={() =>
                            calculatePagination(contactDocsList.currentPage + 1)
                          }
                        >
                          <BsChevronRight />
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div
                className="btn-container mt-5"
                id="btn-container-company-id"
                style={{ marginBottom: "1rem", paddingRight: "0.75rem" }}
              >
                <button
                  className="filter-btn fw-bold cancel_cont_btn canceldisablebutton"
                  style={{
                    height: "42px",
                    // background: "transparent",
                    borderRadius: "12px",
                    // border: "1px solid #5B5B5B",
                    opacity: 1,
                    width: "132px",
                    // color: "#5B5B5B",
                    // fontSize: "14px",
                    // fontWeight:"bold"
                  }}
                  onClick={() => {
                    handelCancel();
                  }}
                >
                  {/* Cancel */}
                  {/* {updateCompanyTranslation[23]?.translation} */}
                  {ttt("")}
                </button>
                {removeaddbtn ? (
                  <button
                    className={
                      roleAccess === process.env.REACT_APP_IS_VIEWER
                        ? "pointerEvent notAllowed filter-btn active-btn fw-bold add-buttons canceldisablebutton"
                        : "filter-btn active-btn fw-bold add-buttons canceldisablebutton"
                    }
                    style={{
                      width: "132px",
                      height: "42px",
                      borderRadius: "12px",
                      backgroundColor: "#00246A",
                      opacity: "100%",
                      color: "white",
                    }}
                  >
                    {showLoader ? (
                      <div className="d-flex justify-content-center">
                        <div className="spinner-border small-loader">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : isUpdating ? (
                      // "Update"
                      updateCompanyTranslation[27]?.translation
                    ) : (
                      // "Add"
                      tt("Add")
                    )}
                  </button>
                ) : (
                  <button
                    disabled={emailError}
                    className={
                      roleAccess === process.env.REACT_APP_IS_VIEWER
                        ? "pointerEvent notAllowed filter-btn active-btn fw-bold add-buttons canceldisablebutton"
                        : "filter-btn active-btn fw-bold add-buttons canceldisablebutton"
                    }
                    style={
                      disableBtn
                        ? {
                            width: "132px",
                            height: "42px",
                            borderRadius: "12px",
                            backgroundColor: "#00246A",
                            opacity: "100%",
                            color: "white",
                            // fontSize: "14px",
                          }
                        : {
                            width: "132px",
                            height: "42px",
                            borderRadius: "12px",
                            backgroundColor: "#00246A",
                            opacity: "100%",
                            color: "white",
                            // fontSize: "14px",
                          }
                    }
                    onClick={handleAdd}
                  >
                    {showLoader ? (
                      <div className="d-flex justify-content-center">
                        <div className="spinner-border small-loader">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : isUpdating ? (
                      // "Update"
                      updateCompanyTranslation[27]?.translation
                    ) : (
                      // "Add"
                      tt("Add")
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="column-2-contact-list-linked" id="column-1-info-id">
            <div className="column-2-main-div ascHideForMobile HideForTablet">
              <p
                className="contacts-linked-text"
                style={{ color: `${primaryColor}` }}
              >
                {/* {updateCompanyTranslation[25]?.translation} */}
                {ttt("")}
              </p>
              <div style={{ overflow: "auto" }}>
                <div style={{ marginTop: "1rem", minWidth: "600px" }}>
                  {clientContactList?.map((contact, index) => {
                    const singleContact = contact?.contactdetails[0];

                    if (contact && contact.contactdetails.length === 0) {
                      return null;
                    }
                    const contactid = contact?.contactdetails[0].contactid;
                    return (
                      <div className="contacts-linked-grid" key={index}>
                        <div>
                          {" "}
                          <td
                            style={{
                              display: "grid",
                              gridTemplateColumns: "18% 75%",
                              columnGap: "3%",
                              alignItems: "center",
                            }}
                            onClick={() => {
                              localStorage.setItem("_tmpConRemoval", true);
                              history.push(
                                `/contactlist/edit-contact/${contactid}`,
                              );
                            }}
                          >
                            {singleContact.photo ? (
                              <>
                                <span
                                  className=""
                                  style={{
                                    backgroundColor: `#FFF`,
                                    textTransform: "uppercase",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "center",
                                    color: "#000",
                                    border: "2px solid #FFFFFF",
                                    overflow: "hidden",
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "100%",
                                    minWidth: "30px",
                                    minHeight: "30px",
                                  }}
                                >
                                  <img
                                    alt=""
                                    src={singleContact.photo}
                                    style={{
                                      minHeight: "50px",
                                      minWidth: "50px",
                                      width: "30px",
                                      height: "30px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </span>
                              </>
                            ) : (
                              <span
                                className=""
                                style={{
                                  borderRadius: "50px",
                                  height: " 30px",
                                  width: " 30px",
                                  backgroundColor: "rgb(149, 167, 198)",
                                  color: " rgb(255, 255, 255)",
                                  display: "flex",
                                  justifyContent: "center",
                                  fontSize: "10px",
                                  fontWeight: "bold",
                                  alignItems: "center",
                                }}
                              >
                                {/* {singleContact?.firstname.charAt(0)}
                                {singleContact?.lastname.charAt(0)} */}

                                {singleContact?.firstname !== "" &&
                                singleContact?.lastname === ""
                                  ? singleContact?.firstname
                                      .slice(0, 2)
                                      .toUpperCase()
                                  : singleContact?.lastname !== "" &&
                                      singleContact?.firstname === ""
                                    ? singleContact?.lastname
                                        .slice(0, 2)
                                        .toUpperCase()
                                    : singleContact?.firstnam !== "" &&
                                        singleContact?.lastname !== ""
                                      ? singleContact?.firstname[0]?.toUpperCase() +
                                        "" +
                                        singleContact?.lastname[0]?.toUpperCase()
                                      : ""}
                              </span>
                            )}
                            <span
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                              }}
                            >
                              <span
                                className="name-style fw-bold"
                                style={{
                                  textAlign: "start",
                                  fontSize: "14px",
                                  marginLeft: "5px",
                                  color: "#333333",
                                  cursor: "pointer",
                                }}
                              >
                                {singleContact?.firstname}{" "}
                                {singleContact?.lastname}
                              </span>
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#444141",
                                  marginLeft: "5px",
                                }}
                              >
                                {" "}
                                {singleContact?.jobtitle}
                              </span>
                            </span>
                          </td>
                        </div>
                        <div>
                          <p
                            style={{
                              marginBottom: "0px",
                              overflow: "hidden",
                              fontSize: "14px",
                            }}
                          >
                            {singleContact?.contactemail[0]?.email}
                          </p>
                          <p
                            style={{
                              marginBottom: "0px",
                              fontSize: "14px",
                            }}
                          >
                            {singleContact?.contactphonenumber[0]?.phoneNumber}
                          </p>
                        </div>
                        <div
                          style={{
                            textTransform: "capitalize",
                            fontSize: "14px",
                          }}
                        >
                          {singleContact?.relationship}
                        </div>
                        <div>
                          <td>
                            <img
                              src={Kebab}
                              alt="kebab"
                              height="16px"
                              width="4px"
                              className={
                                rotate == index
                                  ? "dot-rotate dot-rotated responsive-check mt-4"
                                  : roleAccess ===
                                      process.env.REACT_APP_IS_VIEWER
                                    ? "d-none "
                                    : "dot-rotate responsive-check mt-4"
                              }
                              style={{ cursor: "pointer" }}
                              onClick={(event) => {
                                event.preventDefault();
                                setRotate(index);
                                handleClick(event);
                                setFinalContact(singleContact.contactid);
                              }}
                            />
                          </td>
                          <div>
                            <Menu
                              id="demo-positioned-menu"
                              aria-labelledby="demo-positioned-button"
                              anchorEl={anchorEl}
                              open={open}
                              onClose={handleClose}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                              className="treedotboxshow"
                            >
                              <MenuItem
                                onClick={() => {
                                  handleUploadDoc(singleContact);
                                }}
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  color: "#333333",
                                }}
                              >
                                {" "}
                                <span style={{ position: "relative" }}>
                                  <img
                                    alt=""
                                    src={Image3}
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      marginRight: "1rem",
                                    }}
                                  />
                                </span>
                                {/* {updateCompanyTranslation[29]?.translation} */}
                                {ttt("")}
                                <input
                                  type="file"
                                  accept=".doc,.pdf,.xls,.xlsx,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                  style={{ display: "none" }}
                                  ref={linkContactDocRef}
                                  autoFocus={false}
                                  onChange={(event) => {
                                    setCancelAlert(true);
                                    setTypeInScreen(event.target.value);
                                    const fileUploaded = event.target.files[0];
                                    if (fileUploaded) {
                                      uploadDocForContactAndRedirect(
                                        event,
                                        finalContact,
                                      );
                                    }
                                  }}
                                />
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleContactAssignTask(finalContact);
                                }}
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  color: "#333333",
                                }}
                              >
                                {" "}
                                <span style={{ position: "relative" }}>
                                  <img
                                    src={Image5}
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      marginRight: "1rem",
                                    }}
                                  />
                                </span>
                                {/* {updateCompanyTranslation[30]?.translation} */}
                                {ttt("")}
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleClose();
                                  showModal(true);
                                  setUlnlinkContact(finalContact);
                                  setDeleteUser("");
                                }}
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  color: "#333333",
                                }}
                              >
                                {" "}
                                <span
                                  style={{
                                    position: "relative",
                                  }}
                                >
                                  <img
                                    src={Image4}
                                    alt=""
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      marginRight: "1rem",
                                    }}
                                  />
                                </span>
                                {/* {updateCompanyTranslation[31]?.translation} */}
                                {ttt("")}
                              </MenuItem>
                              <MenuItem
                                className={
                                  roleAccess === process.env.REACT_APP_IS_USER
                                    ? "d-none"
                                    : ""
                                }
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleClose();
                                  showModal(true);
                                  setDeleteUser(finalContact);
                                  setUlnlinkContact("");
                                }}
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  color: "#333333",
                                }}
                              >
                                {" "}
                                <span style={{ position: "relative" }}>
                                  <img
                                    src={Bin}
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      marginRight: "1rem",
                                    }}
                                  />
                                </span>
                                {/* {updateCompanyTranslation[32]?.translation} */}
                                {ttt("")}
                              </MenuItem>
                            </Menu>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
      {popups && (
        <Modal
          show={popups}
          // onHide={handleClose}
          // setpop={setPopups}
          className="modelwidth1"
          style={{
            backgroundColor: "transparent",
            opacity: 0.9,
            marginTop: "10rem",
          }}
        >
          <Modal.Body>
            <div className="flex_class my-5">
              <div className="text1">
                {tttt("The changes made will not be saved.")}
                <br />
                {/* {fetchTransAddContactList[57]?.translation} */}
              </div>

              <div className="pt-3">{tttt("Do you want to proceed?")}</div>

              <div className="pt-5 mt-3">
                <button
                  className="me-2 w-25 asc_no"
                  onClick={() => {
                    setPopups(false);
                  }}
                >
                  {/* no */}
                  {tttt("No")}
                </button>
                <button
                  className="ms-2 w-25 asc_yes"
                  onClick={() => {
                    dispatch(RemoveDocsClientById());
                    history.goBack();
                  }}
                >
                  {/* yes */}
                  {t("YES")}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
      <Modal
        show={modalShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        id="company-doc-modal-id"
      >
        <Modal.Body>
          <div className="column-2-info">
            <div className="doc-heading">
              <div>
                <img
                  src={docicons}
                  style={{
                    width: "20px",
                    height: "20px",
                    marginRight: "0.25rem",
                  }}
                />
                <span
                  className="doc-heading-bold"
                  style={{ color: `${primaryColor}` }}
                >
                  new DOc
                </span>
              </div>
              <div>
                <AiOutlineCloseCircle
                  style={{
                    fontSize: "1.4rem",
                    color: "#707070",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setModalShow(false);
                  }}
                />
              </div>
            </div>
            <div className="upload-new-doc">
              <AiFillPlusCircle
                style={{
                  color: `${primaryColor}`,
                  cursor: "pointer",
                  fontSize: "1.25rem",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  selectDoc.current.click();
                }}
              />
              <input
                type="file"
                accept=".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                name="doc"
                id="doc"
                style={{ display: "none" }}
                ref={selectDoc}
              />
              <span
                className="text-heading-styles"
                style={{ fontSize: "14px" }}
              >
                Upload a new Doc
              </span>
              <div className="underline-contact"></div>
              <p style={{ margin: "1rem 0 0 0" }}>{fileName}</p>
              <div className="lock-round">
                <IoIosLock style={{ color: "#707070", marginBottom: "10px" }} />
              </div>
              <span className="manage-text">Manage Access</span>
            </div>
            <div className="general-access">
              <p className="view-edit">General Access to view & edit</p>
              <div
                className="roles-options"
                style={{
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: "repeat(4,1fr)",
                }}
              >
                <p
                  style={
                    roleId === "08da3f0d-0371-4dd3-8c86-e51222d56198"
                      ? { backgroundColor: `${primaryColor}`, fontSize: "18px" }
                      : { backgroundColor: `#FFFFFF`, fontSize: "16px" }
                  }
                  className={
                    roleId === "08da3f0d-0371-4dd3-8c86-e51222d56198"
                      ? "role-single authorisation-roles active-role active-main"
                      : "role-single authorisation-roles "
                  }
                >
                  owner
                </p>
                <p
                  style={
                    roleId === "08da3f0d-0371-4dd3-8c86-e51222d56199"
                      ? { backgroundColor: `${primaryColor}`, fontSize: "18px" }
                      : { backgroundColor: ``, fontSize: "16px" }
                  }
                  className={
                    roleId === "08da3f0d-0371-4dd3-8c86-e51222d56199"
                      ? "role-single authorisation-roles active-role active-main"
                      : "role-single authorisation-roles "
                  }
                >
                  manager
                </p>
                <p
                  style={
                    roleId === "08da3f0d-0371-4dd3-8c86-e51222d56200"
                      ? { backgroundColor: `${primaryColor}`, fontSize: "18px" }
                      : { backgroundColor: ``, fontSize: "16px" }
                  }
                  className={
                    roleId === "08da3f0d-0371-4dd3-8c86-e51222d56200"
                      ? "role-single authorisation-roles active-role active-main"
                      : "role-single authorisation-roles "
                  }
                >
                  user
                </p>
                <p
                  style={
                    roleId === "08da3f0d-0371-4dd3-8c86-e51222d56201"
                      ? { backgroundColor: `${primaryColor}`, fontSize: "18px" }
                      : { backgroundColor: ``, fontSize: "16px" }
                  }
                  className={
                    roleId === "08da3f0d-0371-4dd3-8c86-e51222d56201"
                      ? "role-single authorisation-roles active-role active-main"
                      : "role-single authorisation-roles "
                  }
                >
                  freelancer
                </p>
              </div>
            </div>
            <div className="people-access general-access">
              <p className="view-edit">People with access</p>
              {docAccessList?.map((access, index) => {
                return (
                  <div className="people-owner-flex">
                    <div className="image-name-flex">
                      <img
                        alt=""
                        src={access?.photo}
                        style={{ width: "35px", height: "35px" }}
                      />
                      <span className="name-flex">
                        <span>{access?.username}</span>
                        <span className="text-heading-styles">
                          {companyId ===
                            "28830f30-b321-4662-a576-f23451677733" &&
                            "Corporat Booking Desk"}
                          {companyId ===
                            "28830f30-b321-4662-a576-f23451677744" &&
                            "ZUID BEHEER"}
                          {companyId ===
                            "28830f30-b321-4662-a576-f23451677755" &&
                            "Residence 32"}
                        </span>
                      </span>
                    </div>
                    <div>
                      <select
                        key={index}
                        style={{ fontsize: "14px", width: "8rem" }}
                        className="input-style add-contact-input-style"
                        name="accesslevelid"
                        id="accesslevelid"
                        value={access.accesslevelid}
                        required
                      >
                        <option
                          value="08da33e9-5a64-4f8c-8d88-49e4982df321"
                          name="08da33e9-5a64-4f8c-8d88-49e4982df321"
                        >
                          View
                        </option>
                        <option
                          value="08da33e9-5a64-4f8c-8d88-49e4982df320"
                          name="08da33e9-5a64-4f8c-8d88-49e4982df320"
                        >
                          Edit
                        </option>
                        <option
                          value="08da33e9-5a64-4f8c-8d88-49e4982df323"
                          name="08da33e9-5a64-4f8c-8d88-49e4982df323"
                        >
                          Owner
                        </option>
                        <option
                          value="08da33e9-5a64-4f8c-8d88-49e4982df322"
                          name="08da33e9-5a64-4f8c-8d88-49e4982df322"
                        >
                          NA
                        </option>
                      </select>
                    </div>
                  </div>
                );
              })}
              <div className="plus-icon-function">
                <div className="plus-icon">
                  <AiOutlinePlus
                    onClick={() => setShowDropPeople(!showDropPeople)}
                    style={{
                      fontSize: "1.5rem",
                      marginTop: "4px",
                      color: "#A7A7A7",
                      cursor: "pointer",
                    }}
                  />
                </div>
                {showDropPeople && (
                  <div className="drop-down-plus" id="drop-down-plus">
                    <div className="search-div-people">
                      <FiSearch
                        style={{
                          marginRight: "6px",
                          marginBottom: "3px",
                        }}
                      />
                      <input
                        type="text"
                        style={
                          searchPeople
                            ? { opacity: "100%" }
                            : { opacity: "50%" }
                        }
                        className="search-people-input"
                        placeholder="Search"
                        value={searchPeople}
                        onChange={(e) => {
                          setSearchPeople(e.target.value);
                        }}
                      />
                    </div>
                    {docPeopleList?.map((people, index) => {
                      const singlePeople = people.userdetails[0];
                      return (
                        <div key={index} className="peoples-flex">
                          <img
                            src={singlePeople.imageurl}
                            style={{ width: "30px", height: "30px" }}
                          />
                          <p style={{ marginBottom: "0" }}>
                            {singlePeople.firstname} {singlePeople.lastname}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={modal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        id="member-error-modal"
        className="modal_start"
      >
        <Modal.Body>
          <p style={{ textAlign: "center", marginTop: "3rem" }}>
            {deleteUser && (
              <span
                style={{
                  color: "#FC685A",
                  fontSize: "var(--responsive-font-18)",
                  display: "inline-block",
                }}
                className="responsive-margin-2"
              >
                {" "}
                This data will be removed from the system
                <br /> and cannot be undone.
              </span>
            )}
            {unlinkContact && (
              <span
                style={{
                  color: "#FC685A",
                  fontSize: "var(--responsive-font-18)",
                  display: "inline-block",
                }}
                className="responsive-margin-2"
              >
                {" "}
                You are unlinking this contact from the <br />
                company linked to and you are turning it <br /> into a Private
                Contact.
              </span>
            )}
            <p
              style={{
                marginTop: "1.5rem",
                fontSize: "var(--responsive-font-18)",
                fontWeight: "bold",
              }}
            >
              Do you want to proceed ?
            </p>
          </p>
          <Row
            style={{
              width: "80%",
              margin: "2rem auto 4rem auto",
              textAlign: "center",
            }}
          >
            <Col style={{ textAlign: "center" }}>
              <button
                className="cancel-btn"
                style={{
                  justifySelf: "center",
                  backgroundColor: "transparent",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  showModal(false);
                  setDeleteUser("");
                  setUlnlinkContact("");
                  setFinalContact("");
                }}
              >
                {t("Cancel")}
              </button>
            </Col>
            <Col>
              <button
                className="cancel-btn invite-btn"
                style={{
                  backgroundColor: `#F76767`,
                  borderColor: `#F76767`,
                }}
                onClick={() => {
                  deleteUser && dispatch(DeleteContacts(deleteUser));
                  unlinkContact && dispatch(CreateUnlinkContact(unlinkContact));
                  showModal(false);
                }}
              >
                {t("YES")}
              </button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      {deleteDocument && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteDocumentFun}
          show={deleteDocument}
          onHide={() => setDeleteDocument(false)}
          title1={"This data will be removed from the system"}
          title2={"and cannot be undone."}
          // title3={updateCompanyTranslation[58]?.translation}
          // no={updateCompanyTranslation[59]?.translation}
          // yes={updateCompanyTranslation[60]?.translation}
          title3={ttt("")}
          no={ttt("")}
          yes={ttt("")}
        />
      )}
    </>
  );
};

export default AddCompany;
